module.exports = __webpack_public_path__ + "img/yidong.64807d7b.png";